/**
 * Precio dual UYU / USD para montos que Hyper formatea en JS (sticky ATC, envío gratis).
 *
 * Genera el mismo HTML que snippets/dual-money.liquid: ambos montos marcados con
 * data-currency-value, y CSS (snippets/currency-head.liquid) muestra el elegido.
 * La cotización llega ya parseada desde Liquid en FoxTheme.settings.usdExchangeRate (0 = apagado).
 */
(function (global) {
  const PLACEHOLDER = /\{\{\s*\w+\s*\}\}/;

  function parseRate(raw) {
    const rate = parseFloat(String(raw ?? '').trim().replace(/,/g, '.'));
    return Number.isFinite(rate) && rate > 0 ? rate : 0;
  }

  function toUsdCents(uyuCents, rate) {
    return Math.round(Number(uyuCents) / rate);
  }

  function usdFormatFrom(moneyFormat) {
    const placeholder = String(moneyFormat || '').match(PLACEHOLDER);
    return `$${placeholder ? placeholder[0] : '{{amount}}'} USD`;
  }

  function createDualCurrency({ rate, moneyFormat, formatMoney }) {
    const usdRate = parseRate(rate);
    const usdFormat = usdFormatFrom(moneyFormat);

    return {
      isActive: usdRate > 0,
      formatDual(cents, format) {
        const uyu = formatMoney(cents, format || moneyFormat);
        if (!usdRate) return uyu;

        const usd = formatMoney(toUsdCents(cents, usdRate), usdFormat);
        return `<span class="dual-money"><span data-currency-value="uyu">${uyu}</span><span data-currency-value="usd">${usd}</span></span>`;
      }
    };
  }

  // Node (tests): sin window global. No alcanza con "typeof module" porque una app
  // puede filtrar un `module` global al browser y nos saltearíamos el init.
  if (typeof window === 'undefined') {
    module.exports = { parseRate, toUsdCents, usdFormatFrom, createDualCurrency };
    return;
  }

  const { FoxTheme } = global;
  FoxTheme.Currency.formatDual = createDualCurrency({
    rate: FoxTheme.settings.usdExchangeRate,
    moneyFormat: FoxTheme.settings.moneyFormat,
    formatMoney: FoxTheme.Currency.formatMoney
  }).formatDual;
})(typeof window === 'undefined' ? globalThis : window);
